/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'extension.charts.aggregateData': 'Samengevoegde gegevens',
  'extension.charts.aggregateDataDescription':
    'Combineer waarden in één gegevenspunt wanneer meerdere rijen dezelfde waarde hebben.',
  'extension.charts.category': 'Categorie',
  'extension.charts.customizeTab': 'Aanpassen',
  'extension.charts.dataMissing.details': 'We kunnen de brontabel van deze grafiek niet vinden op de pagina.',
  'extension.charts.dataMissing.title': 'Geen gegevens om weer te geven',
  'extension.charts.dataTab': 'Gegevens',
  'extension.charts.defaultColumnName': 'Kolom {0}',
  'extension.charts.defaultTitle': 'Naamloze grafiek',
  'extension.charts.defaultYLabel': 'As zonder titel',
  'extension.charts.extensionTitle': 'Grafiek',
  'extension.charts.height': 'Hoogte van de grafiek',
  'extension.charts.height.large': 'Hoger',
  'extension.charts.height.medium': 'Standaard',
  'extension.charts.height.small': 'Lager',
  'extension.charts.horizontal.orientation.label': 'Horizontaal',
  'extension.charts.insert.tooltip': 'Grafiek invoegen',
  'extension.charts.legend': 'Legenda',
  'extension.charts.legend.auto': 'Auto',
  'extension.charts.legend.bottom': 'Onder',
  'extension.charts.legend.left': 'Links',
  'extension.charts.legend.position': 'Positie legenda',
  'extension.charts.legend.right': 'Rechts',
  'extension.charts.legend.show': 'Legenda tonen',
  'extension.charts.legend.top': 'Boven',
  'extension.charts.options.label': 'Grafiekopties',
  'extension.charts.options.tooltip': 'Grafiekopties wijzigen',
  'extension.charts.orientation.label': 'Oriëntatie',
  'extension.charts.seriesNames': 'Datareeksen',
  'extension.charts.showPoints': 'Gegevenspunten tonen',
  'extension.charts.smoothLines': 'Vloeiende lijnen',
  'extension.charts.style': 'Stijl',
  'extension.charts.title': 'Titel',
  'extension.charts.type.bar': 'Balk',
  'extension.charts.type.fieldDescription': 'Type grafiek',
  'extension.charts.type.line': 'Lijn',
  'extension.charts.type.pie': 'Taart',
  'extension.charts.userTitle': 'Titel',
  'extension.charts.vertical.orientation.label': 'Verticaal',
  'extension.charts.xAxis': 'X-as',
  'extension.charts.xLabel': 'Label x-as',
  'extension.charts.yLabel': 'Label Y-as',
};
